export const prefixFieldWithNamespace = (id: string, namespace: string) =>
  `extendedFields.namespaces.${namespace}.${id}`;

export const prefixFieldWithUserFieldsNamespace = (id: string) =>
  prefixFieldWithNamespace(id, '_user_fields');
